module.exports = __webpack_public_path__ + "img/26.fb968e1b.png";